/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Intro_ParagraphInputs */



/**
* | output |
* | --- |
* | "Get all the quick detail you need about oneAI's pricing" |
*
* @param {Pricing_Intro_ParagraphInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_intro_paragraph = /** @type {((inputs?: Pricing_Intro_ParagraphInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Intro_ParagraphInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle wichtigen Informationen zur Preisgestaltung von oneAI auf einen Blick")
	return /** @type {LocalizedString} */ ("Get all the quick detail you need about oneAI's pricing")
});